/**
 * Shipments Route Loaders
 * Loader only prepares filter state, component handles fetching
 */

interface RouterContext { store: { dispatch: (action: unknown) => void } }

export const shipmentsLoader = async () => {
  // Loader doesn't fetch - let component handle it to avoid duplicates
  // This pattern matches Orders page
  return null
}
